import React from 'react';
import { pending } from "./UserApprovalsPageSelector";
import UserApprovalsDashboard from "./UserApprovalsDashboard";

const UserApprovalsDashboardPending = () => {
    return (
        <UserApprovalsDashboard page={pending} />
    );
};

export default UserApprovalsDashboardPending;
